import { cssJoin } from '@shared/util';
import { type ButtonHTMLAttributes, type ElementType, forwardRef } from 'react';

type Props = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'color' | 'onClick'
> & {
  color?: Color;
  p?: BaseSize | 4;
  px?: BaseSize | 4;
  py?: BaseSize | 4;
  bgcolor?: BgColor;
  selected?: boolean;
  onClick?: () => void;
  borderless?: boolean;
  component?: ElementType;
};

const TapArea = forwardRef<HTMLButtonElement, Props>(
  (
    {
      p,
      px,
      py,
      type,
      color,
      bgcolor,
      onClick,
      children,
      disabled,
      selected,
      className,
      borderless = false,
      component = 'button',
      ...restProps
    },
    ref,
  ) => {
    const Component = component;
    const isSelected = selected || restProps['aria-selected'];

    return (
      <Component
        ref={ref}
        {...restProps}
        aria-selected={isSelected}
        type={type || (component === 'button' ? 'button' : undefined)}
        onClick={(e: any) => {
          e?.stopPropagation?.();

          if (!disabled) {
            onClick?.();
          }
        }}
        className={cssJoin(
          'w-full',
          className,
          'tap-area',
          p && `p-${p}`,
          px && `px-${px}`,
          py && `py-${py}`,
          !borderless && 'border',
          !borderless && 'rounded',
          color && `text-${color}`,
          disabled && 'bg-secondary',
          disabled && 'cursor-default',
          isSelected && 'bg-feedback-teal',
          bgcolor && !disabled && `bg-${bgcolor}`,
          !disabled && 'selected:border-primary',
        )}
      >
        {children}
      </Component>
    );
  },
);

TapArea.displayName = 'TapArea';

export default TapArea;
